import { Box, Grid } from '@mui/material';
import EmployeeCard from './Employee/employeeCard.component';
import RenterDetailsCard from './Employee/renterDetailsCard.component';
import React, { useState } from 'react';
import ServicesCard from './servicesCard.component';
import StatusStepper from './statusStepper.component';
import TeamCard from './teamCard.component';
import HeaderCard from './headerCard.component';
import FinanceAndTaxCard from './financeAndTaxCard.component';
import NotesAndCommunicationCard from './notesAndCommunicationCard.component';
import CommunicationCard from './communicationCard.component';
import SurveyResponseDialog from './authorizationSurveyResultsDialog.component';
import AuthTripSummaryCard from '../authorizationTripSummary.component';
import AddressManagementCard from './addressManagementCard.componoent';
import AuthorizationBanking from './authorizationBanking.component';
import CustomFieldValuesCard from './customFieldValuesCard.component';
import AuthorizationTasksCard from './authorizationTasksCard.component';
import PtCodesCard from './ptCodesCard.component';

const AuthorizationDetails = props => {
  const details = props.details;
  const status = details?.authDetails?.summary ? details?.authDetails?.summary.status : 'Init';
  const isReadOnly = Boolean(props.isReadOnly);

  const [renderSurveyModal, setRenderSurveyModal] = useState(false);

  const sendSurveyClicked = async () => {
    setRenderSurveyModal(true);
  };

  return (
    <Box sx={{ padding: '20px' }}>
      {status && details?.authDetails?.dateSummary && details?.authDetails?.userSettings && (
        <StatusStepper
          status={status}
          dateSummary={details?.authDetails?.dateSummary}
          vip={details.authorizationDetails.isVIP}
          webAccess={details?.authDetails?.userSettings.webAccess}
          surveySent={details?.authDetails?.summary.surveySent}
          renderSurveyModal={sendSurveyClicked}
          resetSurveyApiCall={props.resetSurveyApiCall}
        />
      )}
      <Box sx={{ paddingBottom: '16px' }}>
        <HeaderCard clientInfo={props.clientInfo} details={details} id={props.id} emailTemplate={props.emailTemplate} isReadOnly={isReadOnly} />
      </Box>
      <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
        <Grid item xs={12} md={8} rowSpacing={2}>
          <AuthorizationTasksCard
            tasks={props.fileTasks}
            vendors={props.vendors}
            enumerations={props.enumerations}
            id={props.id}
            onCreateTask={isReadOnly ? async () => true : props.createFileTask}
            authorizationDetails={details.authorizationDetails}
            showToast={props.showToast}
            updateTask={isReadOnly ? async () => true : props.updateTask}
            postAuthorizationComment={isReadOnly ? async () => true : props.postAuthorizationComment}
            getTaskComments={props.getTaskComments}
            isReadOnly={isReadOnly}
          />
          <Box sx={{ paddingTop: '16px' }}>
            <NotesAndCommunicationCard
              id={props.id}
              authServices={details?.authDetails?.authServices}
              commentsAndNotes={details?.commentsAndNotes}
              isReadOnly={isReadOnly}
            />
          </Box>
          <Box sx={{ paddingTop: '16px' }}>
            <EmployeeCard
              details={details?.authorizationDetails}
              clientInfo={props.clientInfo}
              employee={{}}
              family={details?.familyMembers}
              id={props.id}
              vendors={props.vendors}
              familyPets={details?.pets}
              isReadOnly={isReadOnly}
            />
          </Box>
          <Box sx={{ paddingTop: '16px' }}>
            <RenterDetailsCard authId={props.id} details={details} isReadOnly={isReadOnly} />
          </Box>
          <Box>
            <AddressManagementCard
              id={props.id}
              addresses={
                details.addresses
                  ? details.addresses.filter(
                    a =>
                      a.addressTypeId !== 'b530b48e-6f25-4356-8d7b-70efb5a8005e' &&
                      a.addressTypeId !== '67a86dee-2aa4-4975-9df0-95368dfec694' &&
                      a.addressTypeId !== 'a9f7b1e1-1335-48f6-b7b3-2d90669a528d'
                  )
                  : []
              }
              destinationAddressId={details?.authorizationDetails?.destinationAddressId}
              hideEdit={isReadOnly}
            />
          </Box>
          <Box sx={{ paddingTop: '16px' }}>
            <AuthTripSummaryCard
              showBasicTable={true}
              familyMembers={details?.familyMembers}
              id={props.id}
              familyPets={details?.pets}
              addresses={details.addresses}
              trips={details?.trips}
              enumerations={props.enumerations}
              hideEdit={isReadOnly}
            />
          </Box>
          {props.clientInfo && props.clientInfo.clientDetails && props.clientInfo.clientDetails.clientDetails.isPtCodeProcessActive && (
            <Box sx={{ paddingTop: '16px' }}>
              <PtCodesCard
                ptCodeHistories={details?.ptCodeHistories}
                fileId={details?.authorizationDetails?.fileId}
                clientRecordId={details?.authorizationDetails?.clientId}
                hideEdit={isReadOnly}
              />
            </Box>
          )}
        </Grid>
        <Grid item xs={12} md={4} rowSpacing={2}>
          <TeamCard
            teamMembers={details?.teamMembers}
            authorizationDetails={details?.authorizationDetails}
            id={props.id}
            hideEdit={isReadOnly}
          />
          <Box sx={{ paddingTop: '16px' }}>
            <ServicesCard
              details={details}
              fileStatus={status}
              surveyInfo={details?.surveys}
              webAccess={details.authorizationDetails.isWebAccessGranted}
              authServices={details.services}
              id={props.id}
              moveType={details.authorizationDetails.moveTypeId}
              enumerations={props.enumerations}
              authorizationDetails={details.authorizationDetails}
              hideEdit={isReadOnly}
            />
          </Box>
          <Box sx={{ paddingTop: '16px' }}>
            <CommunicationCard
              clientInfo={props.clientInfo}
              authorizationDetails={details?.authorizationDetails}
              authServices={details?.services}
              familyMembers={details?.familyMembers}
              transferee={details?.familyMembers.find(f => f.familyRelationshipTypeId === '83ff7cbb-6ec5-4162-a449-9205b0e5c921')}
              id={props.id}
              emailTemplates={props.emailTemplates}
              hideEdit={isReadOnly}
              primaryContact={details?.familyMembers?.find(fm => fm.isPrimary)}
              vendors={props.vendors}
            />
          </Box>
          <Box sx={{ paddingTop: '16px' }}>
            <FinanceAndTaxCard
              details={details}
              clientInfo={props.clientInfo}
              clientTaxPolicies={details?.authTaxAssistance?.clientTaxPolicies}
              id={props.id}
              enumerations={props.enumerations}
              history={props.history}
              isReadOnly={isReadOnly}
            />
          </Box>
          <Box sx={{ paddingTop: '16px' }}>
            <CustomFieldValuesCard customFieldValues={details?.customFieldValues} id={props.id} hideEdit={isReadOnly} clientCustomFields={props.clientInfo.clientDetails.clientCustomFields} divisions={props.clientInfo.clientDetails.clientDivisions} reloPolicies={props.clientInfo.clientDetails.clientRelocationPolicies} authFile={details?.authorizationDetails} />
          </Box>
          <Box sx={{ paddingTop: '16px' }}>
            <AuthorizationBanking
              authorizationBanks={details?.bankAccounts}
              isReadOnly={isReadOnly}
              authorizationId={props.id}
              addresses={details.addresses}
              enumerations={props.enumerations}
            />
          </Box>
        </Grid>
        {renderSurveyModal && (
          <>
            <SurveyResponseDialog
              open={true}
              onCancel={() => setRenderSurveyModal(false)}
              authorization={details?.authDetails?.summary}
              onSubmit={() => setRenderSurveyModal(false)}
              surveyQuestionResponses={details?.surveyQuestionResponses}
            />
          </>
        )}
      </Grid>
    </Box>
  );
};

export default AuthorizationDetails;
